import { Platform, View } from 'react-native';
import { useEffect } from 'react';
import { useStore } from '../../../../contexts/StoreContext';
import { WEBSITE_BASE_URL } from '../../../../app/settings';
import amplitude from '../../../../_shared/amplitude';
import { AnalyticsEvents } from '../../../../_shared/analyticsEvents';
import { Illustration } from '../../../illustration/Illustration';
import { ILLUSTRATION_NAMES } from '../../../illustration/illustration.helper';
import { TestIDs } from 'src/constants/testIDs.constants';
import BaseModal from '../../base-modal/BaseModal';
import { DynamicModalProps } from '../DynamicModal.types';
import { DRAWER_POSITIONS, DRAWER_VIEWS } from 'src/store/drawer/drawer.constants';

export const ModalExitProject = ({ dynamicModalVisible, type, dynamicModalLayer: { id } }: DynamicModalProps) => {
  const {
    i18n,
    user,
    dynamicModal: { closeModal },
    drawer: { openDrawer },
  } = useStore();

  useEffect(() => {
    if (dynamicModalVisible) {
      amplitude.trackEvent(AnalyticsEvents.personalize.goBackAlertView);
    }
  }, [dynamicModalVisible]);

  const onPressPrimaryButton = async () => {
    if (user.isLogged) {
      amplitude.trackEvent(AnalyticsEvents.personalize.goBackAlertAccepted);
      if (Platform.OS === 'web') {
        // If we are on web, we open base url on same tab
        window.location.href = WEBSITE_BASE_URL;
      } else {
        //TODO native version
        //Linking.openURL(WEBSITE_BASE_URL);
      }
    } else {
      closeModal();
      openDrawer({
        drawerView: DRAWER_VIEWS.Login,
        drawerPosition: DRAWER_POSITIONS.Right,
      });
    }
  };

  const onPressSecondaryButton = async () => {
    if (user.isLogged) {
      closeModal();
      amplitude.trackEvent(AnalyticsEvents.personalize.goBackAlertDeclined);
    } else {
      if (Platform.OS === 'web') {
        // If we are on web, we open base url on same tab
        window.location.href = WEBSITE_BASE_URL;
      } else {
        //TODO native version
        //Linking.openURL(WEBSITE_BASE_URL);
      }
    }
  };

  const labelKeySuffix = user.isLogged ? '-with-logged-user' : '';
  const modalWidth = user.isLogged ? undefined : 450;

  return (
    <BaseModal
      testID={TestIDs.EXIT_PROJECT}
      modalIcon={
        <View style={{ width: 100, height: 100 }}>
          <Illustration name={ILLUSTRATION_NAMES.Exit} />
        </View>
      }
      title={i18n.t(`modal-exit-project:title${labelKeySuffix}`)}
      description={i18n.t(`modal-exit-project:description${labelKeySuffix}`)}
      discardText={i18n.t(`modal-exit-project:cancel${labelKeySuffix}`)}
      confirmText={i18n.t(`modal-exit-project:exit${labelKeySuffix}`)}
      handleDiscard={onPressSecondaryButton}
      handleConfirm={onPressPrimaryButton}
      onClose={closeModal}
      onCloseOutside={closeModal}
      isVisible={dynamicModalVisible}
      type={type}
      id={id}
      modalWidth={modalWidth}
    />
  );
};
